module.exports = "app-navbar {\n  position: relative;\n  z-index: 10;\n}\n"